const LocalStorage = {
    clear: function () {
        if (typeof Storage !== 'undefined') {
            localStorage.clear();
        }
    },

    get: function (key, def) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        const _item = localStorage.getItem(key.value);
        if (_item && _item !== 'null') {
            const obj = JSON.parse(_item);
            if (obj.value && obj.version == key.version) {
                return obj.value;
            }
        }
        if (def) {
            return def;
        }
    },

    put: function (key, value) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        let _item = null;
        if (value) {
            _item = { value: value, version: key.version };
        }
        try {
            localStorage.setItem(key.value, JSON.stringify(_item));
        } catch (e) {
            console.log(e);
        }

    },

    remove: function (key) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        localStorage.removeItem(key.value);
    },

    keys: {
        inventory: {
            value: 'inventory',
            version: 1
        },
        recentlyViewed: {
            value: 'recentlyViewed',
            version: 1
        },
        subscribePopup: {
            value: 'subscribePopup',
            version: 1
        }
    },

    RecentlyViewed: {
        _listeners: {},
        _maxCount: 30,

        addListener: (name, listener) => {
            LocalStorage.RecentlyViewed._listeners[name] = listener;
        },

        get: () => LocalStorage.get(LocalStorage.keys.recentlyViewed, []),

        put: (inventory) => {
            const recentlyViewed = LocalStorage.get(LocalStorage.keys.recentlyViewed, []);
            for (let i = 0; i < recentlyViewed.length; i++) {
                if (recentlyViewed[i].id != inventory.id) {
                    continue;
                }
                recentlyViewed.splice(i, 1);
            }
            const item = {
                artist: { artistId: inventory.artist && inventory.artist.artistId, name: inventory.artist && inventory.artist.name },
                available: inventory.available,
                date: inventory.date,
                editions: inventory.editions,
                id: inventory.id,
                images: inventory.images,
                inventoryId: inventory.inventoryId,
                medium: inventory.medium,
                seo: inventory.seo,
                subType: inventory.subType,
                title: inventory.title,
                type: inventory.type
            }
            recentlyViewed.splice(0, 0, item);
            if (recentlyViewed.length > LocalStorage.RecentlyViewed._maxCount) {
                recentlyViewed.splice(LocalStorage.RecentlyViewed._maxCount);
            }
            LocalStorage.put(LocalStorage.keys.recentlyViewed, recentlyViewed);

            // Notify listeners (delayed to give time for listener registration)
            setTimeout(() => {
                for (let id in LocalStorage.RecentlyViewed._listeners) {
                    if (!LocalStorage.RecentlyViewed._listeners[id]) {
                        continue;
                    }
                    LocalStorage.RecentlyViewed._listeners[id](recentlyViewed);
                }
            }, 100);
        },

        removeListener: (name) => {
            LocalStorage.RecentlyViewed._listeners[name] = undefined;
        }
    }
}

export default LocalStorage;